import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import countries from 'utils/countries.json';

import SelectInput from 'components/SelectInput';

const CountrySelect = ({
  testId,
  label,
  name,
  error,
  required,
  placeholder = '',
  control,
  getOptionValue,
  getOptionLabel,
  onChange,
  labelClassName,
  inputBelowLabel,
  isDisabled,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={{ required }}
      render={({ field: { ref, value, ..._field } }) => (
        <SelectInput
          {..._field}
          {...rest}
          value={value}
          testId={testId}
          name={name}
          label={label}
          labelClassName={labelClassName}
          options={countries}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          onChange={(option) => onChange(option, _field.onChange)}
          error={error}
          inputBelowLabel={inputBelowLabel}
          isDisabled={isDisabled}
        />
      )}
    />
  );
};

CountrySelect.propTypes = {
  testId: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  control: PropTypes.shape({}),
  error: PropTypes.string,
  required: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  inputBelowLabel: PropTypes.bool,
  isDisabled: PropTypes.bool
};
CountrySelect.defaultProps = {
  testId: 'country-select',
  label: 'Country',
  name: 'country-select',
  control: {},
  error: null,
  required: false,
  getOptionLabel: (option) => option.name,
  getOptionValue: (option) => option.name,
  onChange: (option, _cb) => _cb(option),
  inputBelowLabel: true,
};

export default memo(CountrySelect);
